"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WINDOW = void 0;

var _core = require("@sentry/core");

const WINDOW = exports.WINDOW = _core.GLOBAL_OBJ;